var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useFormRoot } from '@lucidlink/uicore/form-builder';
export const useAddWorkspaceForm = () => {
    _react_refresh_temp_1();
    const { errors, formData, methods: { injectErrors }, } = useFormRoot();
    const isSubmitDisabled = errors?.workspaceName?.length > 0;
    return {
        formData,
        injectErrors,
        isSubmitDisabled,
    };
};
_react_refresh_temp_1(useAddWorkspaceForm, "z0eGmkpfXSh/O0cxsbzMh1ax0Oc=", false, () => [useFormRoot]);
